import {
  AIContext,
  AIPersonalisationHook,
  AI_CONFIG,
  EmojiRender,
  getCurrentUserHook,
  getTabModule
} from '@nile/components';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { getTabUrlNew } from '@nile/mangifera/src/Pebbles/TabManager';
import { Button, TextStyle } from '@superops/ui-design-system';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { GLOBAL_AI_BOT_STATE } from '../helpers';
import GlobalAIBot from './GlobalAIBot';
const AIGreetings = () => {
  const user = getCurrentUserHook();
  const aiPersonalisationHook = AIPersonalisationHook();
  const userName = user?.name;
  const aiContext = useContext(AIContext);
  const tabContext = useContext(TabContext);
  const location = useLocation();
  const pathName = location.pathname;
  const { showGreeting, setShowGreeting } = aiContext;
  const activeTab = tabContext?.activeTab;
  const getModule = () => {
    const allUrl = getTabUrlNew({ getAllURL: true });
    const moduleData = getTabModule(pathName, allUrl);
    const module = moduleData?.module;
    return module;
  };

  const getConfigData = () => {
    const module = getModule();
    const aiConfig = AI_CONFIG?.[module];
    if (aiConfig?.url) {
      const urlData = aiConfig?.url.find((el) => pathName?.includes(el?.url));
      return urlData?.url || module;
    } else {
      return module;
    }
  };

  const configData = getConfigData();
  const getPersonalisationData = () => {
    switch (configData) {
      case 'TICKET':
        return {
          ticketGreetingsComplete: true
        };
      default:
        null;
    }
  };

  const onGetStarted = () => {
    const personalisationData = getPersonalisationData();
    if (personalisationData && aiPersonalisationHook?.saveAIPersonalisation) {
      aiPersonalisationHook?.saveAIPersonalisation(personalisationData);
    }
    setShowGreeting(false);
  };

  return (
    <div className="flex col actr jctr g10 text-white">
      <div className="greetings-rive-bot">
        <GlobalAIBot riveState={GLOBAL_AI_BOT_STATE.entry} />
      </div>

      <div>
        <div>
          <TextStyle weight="SemiBold">
            <div className="mb-5 flex actr jctr g5">
              Hi {userName}{' '}
              <div>
                <EmojiRender emoji={'👋'} />
              </div>
            </div>
          </TextStyle>

          <TextStyle>
            <div className="tcenter">
              <FormattedMessage id="msp.ai.ticket.details.monica.onboard.message" />
            </div>
          </TextStyle>
        </div>
      </div>

      <div>
        <Button aiPrimary size="slim" onClick={onGetStarted}>
          <div className="fsize12">
            <FormattedMessage id="onboarding.video.get.started" />
          </div>
        </Button>
      </div>
    </div>
  );
};
export default AIGreetings;
